<template>
	<div class="liker">
		<div ref="likerContainer" class="liker-canvas"></div>
		<slot></slot>
	</div>
</template>

<script>
import * as PIXI from "pixi.js";
import { HeartsFlow, randomInt, randomNumberInRange } from "./like-button.js";

export default {
	props: {
		sources: {
			type: Array,
			default: () => {
				return [];
			},
		},
	},
	data() {
		return {
			app: {},
			originRect: {},
			texs: [],
		};
	},
	watch: {},
	mounted() {
		this.$nextTick(() => {
			const el = this.$slots.default[0].elm;
			this.originRect = el.getBoundingClientRect();

			this.app = new PIXI.Application({ width: window.innerWidth, height: window.innerHeight, backgroundAlpha: 0 });
			this.$refs.likerContainer.appendChild(this.app.view);

			this.sources.map((url) => {
				this.texs.push(PIXI.Texture.from(url));
			});

			this.app.ticker.add((delta) => {
				this.app.stage.children.map((sp) => {
					if (sp && !sp.destroyed) {
						sp.ticker(delta);
					}
				});
			});

			// console.log("xxxxxxxxxx like-button", this.originRect);
		});
	},
	destroyed() {},
	methods: {
		add() {
			if (this.originRect.width === 0) {
				const el = this.$slots.default[0].elm;
				this.originRect = el.getBoundingClientRect();
			}
			const _size = randomInt(20, 40);
			const _option = {
				x: this.originRect.x - 50,
				y: this.originRect.y - 20,
				width: _size,
				height: _size,
				angleOffset: randomInt(10, 30),
				radiusX: randomInt(10, 40),
				speedY: randomNumberInRange(1.5, 3),
				disY: randomInt(150, 200),
			};
			// console.log("xxxxxxxxxx like", _option);

			const sp = new HeartsFlow(this.texs[randomInt(0, this.texs.length - 1)], _option);
			sp.on("dead", (_sp) => {
				this.app.stage.removeChild(_sp);
			});

			this.app.stage.addChild(sp);
		},
	},
};
</script>

<style>
.liker-canvas {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	pointer-events: none;
}
</style>
